import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Location, ViewportScroller } from '@angular/common';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  // bsModalRef?: BsModalRef;
  isUserLogged: any | null;
  // currentDate;
  currentUrl: string;
  path: Array<string>;
  userInitials: string;
  isMmcUser: boolean;

  whiteTitle: boolean = false;
  constructor(
    private authService: AuthService,
    private router: Router,
    private location: Location,
    private scroller: ViewportScroller,
    private detectChanges: ChangeDetectorRef
  ) {
    this.path = [];
    this.isUserLogged = null;
  }
  ngOnInit(): void {
    this.authService.getUserLogged().subscribe((user: any) => {
      this.isUserLogged = user;
      if (this.isUserLogged) {
        this.isMmcUser = user.client.name.toLowerCase() === 'mmc' ? true : false;
        this.userInitials = user.name
          .split(' ', 2)
          .map(word => (word = word[0]))
          .join('')
          .toUpperCase();
      }
    });

    this.router.events.subscribe({
      next: response => {
        if (response['routerEvent'] && response['routerEvent'].url) {
          this.whiteTitle = false;
          if (response['routerEvent'].url.indexOf('catalog/public') > -1) {
            this.whiteTitle = true;
          }
        }
        if (response instanceof NavigationEnd) {
          this.whiteTitle = false;
          if (response.url.indexOf('catalog/public') > -1) {
            this.whiteTitle = true;
          }
          // console.log(this.whiteTitle);
          if (response.url !== '/') {
            const urlSplitted = response.url.split('/');
            this.currentUrl =
              urlSplitted[2] == undefined ? '/' + urlSplitted[1] : '/' + urlSplitted[1] + '/' + urlSplitted[2];
          } else {
            this.currentUrl = '/dashboard';
          }
          this.detectChanges.detectChanges();
        }
      },
    });
  }

  public changePassword() {
    this.router.navigate(['/update-password']);
  }

  public logout() {
    this.authService.logout();
    localStorage.removeItem('user');
    // this.authService.logout().subscribe({
    //   next: () => {
    //     this.router.navigate(['/login']);
    //   },
    //   error: err => {
    //     console.error('Error durante el logout', err);
    //   },
    // });
  }

  public scroll(el) {
    this.scroller.scrollToAnchor(el);
  }

  public navigateBack() {
    this.location.back();
  }
}
